import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { api } from '../lib/api'
import { fmtDate, money, type AdminOrder, type PageMeta } from '../lib/types'
import { StatusBadge } from '../components/StatusBadge'

export function ProjectsPage({ moderationOnly = false }: { moderationOnly?: boolean }) {
  const [params, setParams] = useSearchParams()
  const q = params.get('q') || ''
  const page = Number(params.get('page') || 1)
  const qc = useQueryClient()
  const qs = new URLSearchParams({ page: String(page), page_size: '50' })
  if (q) qs.set('q', q)
  if (moderationOnly) qs.set('moderation_status', 'pending')

  const { data, isLoading } = useQuery({
    queryKey: ['orders', qs.toString()],
    queryFn: () => api<{ items: AdminOrder[]; meta: PageMeta }>(`/admin/orders?${qs}`),
  })

  const moderate = useMutation({
    mutationFn: ({ id, action }: { id: string; action: string }) =>
      api(`/admin/orders/${id}/moderate`, { method: 'POST', body: JSON.stringify({ action }) }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['orders'] }),
  })

  return (
    <div>
      <h1 className="page-title">{moderationOnly ? 'Модерация проектов' : 'Все проекты'}</h1>
      <p className="page-sub">{moderationOnly ? 'Очередь на проверку' : 'Каталог проектов платформы'}</p>
      <div className="toolbar">
        <input className="input" placeholder="Поиск по названию" value={q} onChange={(e) => {
          const next = new URLSearchParams(params)
          if (e.target.value) next.set('q', e.target.value); else next.delete('q')
          next.delete('page')
          setParams(next)
        }} />
      </div>
      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>Название</th>
              <th>Заказчик</th>
              <th>Бюджет</th>
              <th>Статус</th>
              <th>Модерация</th>
              <th>Отклики</th>
              <th>Дата</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && <tr><td colSpan={8}>Загрузка…</td></tr>}
            {data?.items.map((o) => (
              <tr key={o.id}>
                <td style={{ maxWidth: 260, whiteSpace: 'normal' }}>{o.title}</td>
                <td>{o.author_name || '—'}</td>
                <td>{o.budget_max != null ? money(o.budget_max, o.currency) : '—'}</td>
                <td><StatusBadge value={o.status} /></td>
                <td><StatusBadge value={o.moderation_status} /></td>
                <td>{o.proposals_count}</td>
                <td>{fmtDate(o.created_at)}</td>
                <td>
                  <div className="row" onClick={(e) => e.stopPropagation()}>
                    <button className="btn btn-success" onClick={() => moderate.mutate({ id: o.id, action: 'approve' })}>Одобрить</button>
                    <button className="btn btn-danger" onClick={() => moderate.mutate({ id: o.id, action: 'hide' })}>Скрыть</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
